var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 451,
    viewBox: "0 0 814 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 451,
    fill: "#727E84"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 762,
    transform: "translate(164 -156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.5 37.0834C360.35 37.0834 322.083 75.35 322.083 122.5C322.083 169.65 360.35 207.917 407.5 207.917C454.65 207.917 492.917 169.65 492.917 122.5C492.917 75.35 454.65 37.0834 407.5 37.0834ZM398.958 182.292V165.208H416.042V182.292H398.958ZM426.035 123.952L433.723 116.094C438.592 111.225 441.667 104.392 441.667 96.875C441.667 77.998 426.377 62.7084 407.5 62.7084C388.623 62.7084 373.333 77.998 373.333 96.875H390.417C390.417 87.4792 398.104 79.7917 407.5 79.7917C416.896 79.7917 424.583 87.4792 424.583 96.875C424.583 101.573 422.704 105.844 419.544 108.919L408.952 119.681C402.802 125.917 398.958 134.458 398.958 143.854V148.125H416.042C416.042 135.313 419.885 130.188 426.035 123.952Z",
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 247,
    width: 285,
    height: 39,
    fill: "#80BDE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 294,
    width: 221,
    height: 30,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 354,
    width: 119,
    height: 49,
    rx: 12,
    fill: "#268FCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 379H372V385H370V379H364V377H370V371H372V377H378V379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691,
    width: 123,
    height: 451,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 650,
    width: 9,
    height: 451,
    fill: "#6A767C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 451,
    fill: "#B9BFC2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123,
    width: 9,
    height: 451,
    fill: "#6A767C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 451,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateBanner);
export default __webpack_public_path__ + "static/media/empty-state-banner.17859eed18174594af4d02a9223ccb5f.svg";
export { ForwardRef as ReactComponent };